<template>
  <PLogin
    v-if="activeForm === 'login'"
    :prevent-redirection="true"
    :goal-id="plgGoalId"
    @logged-in="handleLoggedIn"
  >
    <template #cadastro>
      <span
        class="c-text-hyperlink ui-cursor-pointer"
        @click="activeForm = 'create-form'"
      >
        Faça o cadastro
      </span>
    </template>
    <template #forgotPassword>
      <span
        class="c-text-hyperlink ui-cursor-pointer c-text-gray"
        @click="activeForm = 'forgot-password'"
      >
        Esqueci minha senha
      </span>
    </template>
    <template #accessKey>
      <c-button
        outline
        class="ui-w-full"
        size="lg"
        @click="activeForm = 'enviar-chave-de-acesso'"
      >
        Login via chave de acesso
      </c-button>
    </template>
  </PLogin>
  <PEsqueciSenha
    v-else-if="activeForm === 'forgot-password'"
    :auth-popover="true"
    @recovery-password="handleRecoveryPasswordSent"
  >
    <template #return>
      <c-button
        outline
        class="ui-w-full"
        data-cy="registerButton"
        size="lg"
        @click="activeForm = 'login'"
      >
        Voltar
      </c-button>
    </template>
  </PEsqueciSenha>
  <PCadastroRapido
    v-else-if="activeForm === 'create-form'"
    :prevent-navigation="true"
    @registered="handleRegistered"
    @logged-in="handleLoggedIn"
    :goal-id="plgGoalId"
  >
    <template #login>
      <span
        class="c-text-hyperlink ui-cursor-pointer"
        @click="activeForm = 'login'"
      >
        Acesse aqui
      </span>
    </template>
  </PCadastroRapido>
  <PEnviarChaveAcesso
    v-else-if="activeForm === 'enviar-chave-de-acesso'"
    :prevent-navigation="true"
    @sent="handleAccessKeySent"
  >
    <template #back>
      <c-button
        outline
        class="ui-w-full"
        size="lg"
        @click="activeForm = 'login'"
      >
        Voltar
      </c-button>
    </template>
    <template #login>
      <span
        class="c-text-hyperlink ui-cursor-pointer"
        @click="activeForm = 'login'"
      >
        Faça login com outro email
      </span>
    </template>
  </PEnviarChaveAcesso>
  <PConfirmeSeuCodigo
    v-else-if="activeForm === 'confirme-seu-codigo'"
    :prevent-navigation="true"
    :email-prop="registeredEmail"
    :goal-id="plgGoalId"
    @logged-in="handleLoggedIn"
  >
    <template #back>
      <c-button
        outline
        class="ui-w-full"
        size="lg"
        @click="activeForm = codeBackFormName"
      >
        Voltar
      </c-button>
    </template>
    <template #login>
      <span
        class="c-text-hyperlink ui-cursor-pointer"
        @click="activeForm = 'login'"
      >
        Faça login com outro email
      </span>
    </template>
  </PConfirmeSeuCodigo>
</template>

<script>
import PLogin from '@/components/p-login/index.vue';
import PEsqueciSenha from '@/components/p-esqueci-senha/index.vue';
import PCadastroRapido from '@/components/p-cadastro-rapido/index.vue';
import PEnviarChaveAcesso from '@/components/p-enviar-chave-acesso/index.vue';
import PConfirmeSeuCodigo from '@/components/p-confirme-seu-codigo/index.vue';
import { CButton } from '@estrategiahq/coruja-web-ui/dist/coruja-web-ui.cjs';
import { ALLOWED_POST_MESSAGE_ORIGINS, ALLOWED_REDIRECT_DOMAINS } from '@/consts';

export default {
  name: 'AuthPopup',
  components: {
    PLogin,
    PEsqueciSenha,
    PCadastroRapido,
    PEnviarChaveAcesso,
    PConfirmeSeuCodigo,
    CButton,
  },
  data: () => {
    return {
      activeForm: 'login',
      goalId: null,
      plgGoalId: null,
      frontStudentUrl: null,
      validForms: ['login', 'create-form', 'forgot-password', 'enviar-chave-de-acesso', 'confirme-seu-codigo'],
      registeredEmail: '',
      codeBackFormName: 'enviar-chave-de-acesso',
    };
  },
  async mounted() {
    await this.handleUserAlreadyLoggedIn();
    const activeForm = this.$route.query.active_form || null;
    if (activeForm && this.validForms.includes(activeForm)) {
      this.activeForm = activeForm;
    }

    if (this.$route.query.goal_id) {
      this.plgGoalId = this.$route.query.goal_id;
    }

    if (this.$route.query.objetivo_id) {
      if (this.$route.query.target) {
        this.goalId = this.$route.query.objetivo_id;

        this.frontStudentUrl = this.$vertical.getUrl(this.$route.query.target);
      } else {
        this.$toast.show({
          type: 'error',
          text: 'Redirecionamento Inválido',
          timeout: 0,
        });
      }
    }
  },
  watch: {
    activeForm: {
      handler() {
        this.notifyFormChange();
      },
      immediate: true,
    },
  },
  methods: {
    async handleUserAlreadyLoggedIn () {
      // redireciona para o target caso o usuário esteja logado
      try {
        await this.$services.accounts.validate();
        this.redirectToTarget();
      } catch (e) {
        console.error(e);
      }
    },
    redirectToTarget () {
      const target = URL.parse(this.$route.query.target);
      const isValidTarget = target?.host && ALLOWED_REDIRECT_DOMAINS.some(domain => target.host.endsWith(domain));
      if (isValidTarget) {
        window.location.href = this.$route.query.target;
      }
    },
    handleLoggedIn(logindata) {
      try {
        this.sendDataToWindowOpener(logindata);
      } catch (e) {
        console.error(e);
      } finally {
        this.redirectToTarget();
      }
    },
    handleRegistered({ email }) {
      this.registeredEmail = email;
      this.codeBackFormName = 'create-form';
      this.activeForm = 'confirme-seu-codigo';
    },
    handleAccessKeySent({ email }) {
      this.registeredEmail = email;
      this.codeBackFormName = 'enviar-chave-de-acesso';
      this.activeForm = 'confirme-seu-codigo';
    },
    sendDataToWindowOpener(data) {
      if (!document.referrer) {
        return;
      }

      const origins = ALLOWED_POST_MESSAGE_ORIGINS[process.env.VUE_APP_ENVIRONMENT] || [];
      const validOrigin = origins?.find(o => new URL(document.referrer).origin === o) || '';
      if (data?.email && data?.token) {
        // Enviar os dados para a janela de origem
        if (window.opener) {
          window.opener.postMessage({
            loggedIn: true,
            ...data,
          }, validOrigin);

        } else {
          window.top.postMessage({
            loggedIn: true,
            ...data,
          }, validOrigin);
        }

        if (this.goalId) {
          this.createTrialAccessByGoalId();
        } else {
          // Fechar a popup
          window.close();
        }

      } else {
        this.$toast.show({
          type: 'error',
          text: 'Erro ao acessar dados do usuário! Realize login novamente.',
          timeout: 3000,
        });
        this.activeForm = 'login';
      }
    },
    handleRecoveryPasswordSent() {
      this.$toast.show({
        type: 'success',
        text: 'Se o email estiver cadastrado, você receberá um link para redefinir a senha.',
        timeout: 3000,
      });
      this.activeForm = 'login';
    },
    async createTrialAccessByGoalId() {
      try {
        await this.$services.bff.createTrialAccessByGoalId(this.goalId);

        window.resizeTo(screen.width, screen.height);
        window.location.href = this.frontStudentUrl;
      }
      catch (e) {
        this.$toast.show({
          type: 'warning',
          text: 'Erro ao criar acesso. Tente novamente.',
          timeout: 3000,
        });
      }
    },
    async notifyFormChange() {
      if (!document.referrer) {
        return;
      }
      const origins = ALLOWED_POST_MESSAGE_ORIGINS[process.env.VUE_APP_ENVIRONMENT] || [];
      const validOrigin = origins?.find(o => new URL(document.referrer).origin === o) || '';

      if (!validOrigin) {
        return;
      }

      await this.$nextTick();

      const message = {
        type: 'form-change',
        activeForm: this.activeForm,
        height: this.$el.scrollHeight,
      };
      if (window.opener) {
        window.opener.postMessage(message, validOrigin);
      } else {
        window.top.postMessage(message, validOrigin);
      }
    },
  },
};
</script>
